<template>
    <div>
        <!-- 选项卡]] -->
        <div class="my-content-tabs my-content-1">
            <div class="g-status">
                <a class="arrow-left js-status-left" @click="swiperPrev"><i class="ico ico-arrow-left"></i></a>
                <a class="arrow-right js-status-right" @click="swiperNext"><i class="ico ico-arrow-right"></i></a>
                <div class="swiper-container js-status-swiper" id="swiper-tab-task">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item,index) in swiperItem" :key="item.id">
                            <div class="title" :class="{active: index == curSwiper}" @click="changeSwiper(index,item)">{{item.name }}<span class="num">（{{item.num}}）</span></div>
                        </div>
                    </div>
                </div>
                <!-- 0629新增[[-->
                <div class="filter-draft" v-if="curTab != 2" @click="checkDraftList" :class="isDraft ? 'filter-draft-active' : ''">
                    <div class="draft-ico"></div>
                    <span class="draft-text">草稿箱</span>
                </div>
                <!-- 0629新增[[-->
            </div>

            <div class="search searchs f-clearfix"  v-if="!isDraft">
                <select-box :selectList="allGame" :itemTitle="'游戏'" :selected.sync="params.gameId"></select-box>
                <select-box :selectList="getArticleTypeList" :itemTitle="'内容类型'" :selected.sync="params.type" :placeholder="'请选择内容类型'">

                </select-box>

                <!-- <select-box
                        :selectList="articleStatusList" :itemTitle="'内容状态'"
                            :selected.sync="params.status"
                            :placeholder="'选择内容状态'">

                </select-box> -->
                <select-box v-if="curTab===1" :selectList="demandList" :itemTitle="'订单名称'" :selected.sync="params.demandItemId" :placeholder="'请选择订单'">
                </select-box>
                <select-box v-if="curTab===2" :selectList="activityList" :itemTitle="'活动名称'" :selected.sync="params.activityId" :placeholder="'请选择活动'">
                </select-box>

                <select-box :selectList="taskList" :itemTitle="'活动名称'" :selected.sync="params.missionId" :placeholder="'请选择活动'">
                </select-box>

                <div class="list list-title">
                    <!--<div class="list">-->
                    <p class="name"><label for="keyword">内容标题</label></p>
                    <div class="g-select f-fl">
                        <input class="input" name="keyword" type="text" placeholder="请输入要搜索的内容标题" v-model.trim="params.title">
                    </div>
                </div>
                <div class="inquire">
                    <input class="btn" type="button" value="查询" @click="getArticleList">
                </div>
            </div>

            <ul class="freelance-list normal">
                <li class="list-empty f-clearfix" v-if="!articleList.length">
                    <img src="~Assets/img/pages/v4/search-null.png" />
                </li>
                <li class="list" v-for="article in articleList" :key="article.id">
                    <div class="f-clearfix">
                        <p class="pic f-fl" @click="preview(article)" style="cursor: pointer">
                            <img class="pic-img" :src="article.cover" alt="">
                        </p>
                        <div class="txt f-fl">
                            <h3 class="title">
                                <span class="type">{{ getArticleType(article) }}</span>
                                <a class="name f-hide-col-1 js-open-view" href="javascript:;" @click="preview(article)">{{ article.articleTitle }}</a>
                            </h3>
                            <div class="intro f-hide-col-1">活动：<span>{{`${article.missionTitle}`}}</span></div>
                            <div class="author">
                                <span class="time">{{ article.created ? article.created.substr(0,10) : '' }}</span>
                                <div class="vid-pop f-fr" v-if="article.vid">
                                    <span class="vid-pop-title">腾讯视频链接vid</span>
                                    <div class="vid-pop-cnt">
                                        <div class="tooltip-arrows-down"></div>
                                        <p>vid: {{article.vid}}</p>
                                        <p>链接: {{`https://v.qq.com/x/page/${article.vid}.html`}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="operation draft f-fl">
                            <!-- 0629修改 -->
                            <p class="status">
                                <span class="color-theme">{{ getArticleStatusText(article.articleStatus)}}</span>
                                <span v-if="article.articleStatus==50" :title="`驳回原因：${article.reject_remark}`" class="reject-remark">？</span>
                            </p>
                            <p class="btn f-clearfix" v-if="!isDraft">
                                <a class="g-btn" href="javascript:;" v-if="[10,50].includes(article.articleStatus)" @click="editArticle(article)">编辑
                                </a>
                                <a class="g-btn preview-video" href="javascript:;" v-if="article.operation.preview" @click="preview(article)">预览</a>
                                <a class="g-btn js-open-reject" href="javascript:;" v-if="[10,50].includes(article.articleStatus)" @click="deleteArticle(article)">删除</a>
                            </p>

                            <p class="btn f-clearfix" v-else>
                                <a class="g-btn f-fl" href="javascript:;" @click="editArticle(article)">编辑</a>
                                <!-- <a class="g-btn f-fr" href="javascript:;" @click="publishArticle(article)">{{curTab ==0 ? '发布' : '投稿'}}</a> -->
                                <a class="g-btn preview-video f-fl" href="javascript:;" @click="preview(article)">预览</a>
                                <a class="g-btn js-open-reject" href="javascript:;" @click="deleteArticle(article)">删除</a>
                            </p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 分页[[ -->
        <pagination v-if="paginationConf.total >0" :total="paginationConf.total" :page-size="paginationConf.pageSize" @change="pageChange" ref="pager">
        </pagination>
        <!-- 分页]] -->

        <!--内容预览 start-->
        <content-preview ref="contentPreview"></content-preview>
        <video-preview ref="videoPreview"></video-preview>
        <!--内容预览 end-->
    </div>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/manage/content.scss";
@import "~Assets/vendor/swiper/swiper-3.2.7.min.css";
.my-content .freelance-list .operation .btn .g-btn {
    margin: 3px;
}
.list-empty {
    width: 100%;
    text-align: center;
    height: 300px;
    margin-top: 50px;
}
.filter-draft-active {
    cursor: auto;
}
.reject-remark {
    cursor: pointer;
    color: #fd7e28;
}
</style>
<script>
import Swiper from 'Assets/vendor/swiper/swiper-3.2.7.min.js';
import pagination from 'Components/v4/pagination/pagination_v4';
import selectBox from 'Components/v4/dropdown/select_box';
import contentPreview from 'Components/v4/pop/content_preview';
import videoPreview from 'Components/v4/pop/video_preview';
import {
    TaskAll, AllGame, ArticleDetail, ArticleStatistics, ArticleDelete, TaskMyArticleList, ActivityArticleListDraft, ActivityDraftDelete
} from 'Services/getData.js';
export default {
    data() {
        return {
            allGame: [],
            articleType: [
                {
                    name: '请选择', id: ''
                },
                {
                    name: "图文", id: 0
                },
                {
                    name: "视频", id: 1
                },
                {
                    name: "小说", id: 50
                },
                {
                    name: "漫画", id: 60
                }
            ],
            params: {
                gameId: '',
                type: '',
                title: '',
                articleStatus: '', // 内容同步状态 (1同步中 2已同步 3已驳回)
                checkStatus: '', // ugc 验收状态
                status: -1, // -1代表全部
                page: 1,
                pageSize: 10,
                missionId: ''
            },
            curTab: 0,
            mySwiper: '',
            curSwiper: 0,
            paginationConf: {
                total: 0,
                pageSize: 10
            },
            articleList: [],
            articleStat: [],
            articleStatusList: [
                {
                    name: '请选择', id: -1
                },
                {
                    name: '已发布', id: 30
                },
                {
                    name: '已驳回', id: 50
                },
                {
                    name: '已通过', id: 20
                },
                {
                    name: '待审核', id: 10
                },
                {
                    name: '供应商已通过', id: 18
                },
                {
                    name: '发布中', id: 25
                }
            ],
            taskList: [],
            isDraft: '',
            swiperItem: [
                {
                    name: '全部', status: -1, num: 0, show: true
                },
                {
                    name: '已发布', status: 30, num: 0, show: true
                },
                {
                    name: '已驳回', status: 50, num: 0, show: true
                },
                {
                    name: '已通过', status: 20, num: 0, show: true
                },
                {
                    name: '待审核', status: 10, num: 0, show: true
                },
                {
                    name: '供应商验收通过', status: 18, num: 0, show: true
                },
                {
                    name: '发布中', status: 25, num: 0, show: true
                }
            ]
        }
    },
    components: {
        pagination, selectBox, contentPreview, videoPreview
    },
    mounted() {
        this.getAllGame();
        this.initSwiper();
        this.getArticleList();
        this.getArticleStat(7);
        this.getTaskList();
    },
    methods: {
        checkDraftList() {
            this.isDraft = !this.isDraft;
            this.curSwiper = null;
            if (!this.isDraft) {
                this.resetPageConf();
            }
            this.getArticleList();
        },
        async getTaskList() {
            let res = await TaskAll();
            if (res.status === 200 && res.data.code == 0) {
                res.data.data.forEach((v, k) => {
                    v.name = v.title;
                })
                this.taskList = res.data.data;
            }
        },
        getArticleList() {
            this.articleList = [];
            this.getTaskArticleList();
        },
        pageChange(param) {
            // this.params.pageSize = param.pageSize; // 发送给接口的字段
            this.params.page = param.pageIndex; // 发送给接口的字段
            this.getArticleList();
        },
        preview(article) {
            if (this.curTab == 0 && this.isDraft) {
                if (article.articleType === 0) {
                    this.$refs.contentPreview.loadInfo(article.id, true, false, true);
                } else {
                    this.$refs.videoPreview.remotePreview(article.id, true, false, true);
                }
            } else {
                if (article.articleType == 0) {
                    this.$refs.contentPreview.loadInfo(article.id);
                } else if (article.articleType == 1) {
                    this.$refs.videoPreview.remotePreview(article.id);
                } else {
                    this.$refs.contentPreview.loadInfo(article.id);
                }
            }
        },
        editArticle(article) {
            let name = article.articleType == 0 ? 'v4-task-picture' : 'v4-task-video'
            this.$router.history.push({
                name: name, 
                params: {
                    taskId: article.missionId, 
                    articleId: article.id
                },
                query: {
                    type: this.isDraft ? 'draft' : ''
                }
            });
        },
        publishArticle(article) {
            this.$router.history.push({
                name: 'v4-contribute-contribute', query: {
                    draftId: article.id
                }
            });
        },
        deleteArticle(article) {
            let self = this;
            this.$confirm('确认删除此内容').then(() => {
                self.doDeleteArticle(article.id);
            }).catch((e) => {
            });
        },
        async doDeleteArticle(id) {
            let res;
            if(this.isDraft){
                res = await ActivityDraftDelete({
                    draftId: id
                });
            }else{
                res = await ArticleDelete(id);
            }

            if (res.status === 200 && res.data.code == 0) {
                this.$alert('删除成功');
            }
            this.getArticleList();
        },

        async getArticleStat(type) {
            let res = await ArticleStatistics({
                type: type
            });
            let statMap = new Map();
            if (res.status === 200 && res.data.code == 0) {
                let stat = res.data.data;
                stat.filter((s) => {
                    statMap.set(s.status, s.num);
                });
            }
            this.swiperItem.map((item) => {
                item.num = statMap.get(item.status);
                return item;
            });
            console.log(this.swiperItem)
        },
        async getTaskArticleList() {
            // 自由投稿
            let response;
            let param = this.params;
            if (this.isDraft) {
                response = await ActivityArticleListDraft(param);
            } else {
                if (param.checkStatus.length === 0) { // 设置初始值
                    param.checkStatus = -1;
                }
                response = await TaskMyArticleList(param);
            }

            let result = response.data;
            if (result.code == 0) {
                this.articleList = result.data.data.map((article) => {
                    article.operation = {
                        preview: true
                    }
                    return article;
                });
                this.paginationConf.total = result.data.total;
            }
        },
        initSwiper() {
            this.mySwiper = new Swiper('#swiper-tab-task', {
                paginationClickable: true,
                slidesPerView: 'auto',
                initialSlide: 1,
                slideToClickedSlide: true,
                centeredSlides: true,
                onTransitionEnd: function (swiper) {
                    if (swiper.progress == 1) {
                        swiper.activeIndex = swiper.slides.length - 1
                    }
                }
            })
        },
        swiperPrev() {
            this.mySwiper.slidePrev();
        },
        swiperNext() {
            this.mySwiper.slideNext();
        },
        changeSwiper(index, item) {
            this.isDraft = false;
            this.curSwiper = index;
            this.params.page = 1;
            this.params.articleStatus = 0;
            this.params.status = item.status;

            this.getArticleList();
        },
        async getAllGame() {
            let res = await AllGame();
            if (res.data && res.data.data.length) {
                this.allGame = res.data.data;
            }
        },
        resetPageConf() {    // 初始化查询数据
            this.isDraft = false;
            this.params.page = 1;
            this.curSwiper = 0;
            this.mySwiper.slideTo(this.curSwiper + 1);
            this.params.status = -1;

        },
        getArticleType(item) {
            let type = '';
            switch (parseInt(item.articleType)) {
                case 0:
                    type = '图文';
                    break;
                case 1:
                    type = '视频';
                    break;
            }
            return `【${type}】`;
        },
        getArticleStatusText(articleStatus) {
            let text = '';
            // 任务 : -1全部 30已发布 50已驳回 20已通过 10待审核 18供应商已通过 25发布中
            switch (articleStatus) {
                case 30:
                    text = '已发布';
                    break;
                case 50:
                    text = '已驳回 ';
                    break;
                case 20:
                    text = '已通过 ';
                    break;
                case 10:
                    text = '待审核';
                    break;
                case 18:
                    text = '供应商已通过';
                    break;
                case 23:
                case 25:
                    text = '发布中';
                    break;

            }
            return text;
        }
    },

    computed: {
        getArticleTypeList() {
            return [
                {
                    name: '请选择', id: ''
                },
                {
                    name: '图文', id: 0
                },
                {
                    name: '视频', id: 1
                }
            ];
        }
    }
}
</script>
